import React from 'react';
import Helmet from 'react-helmet';
import strings from 'app/strings';

import './page-not-found.less';

const Unauthorized = () => (
  <div className='PageNotFound'>
    <Helmet title='Unauthorized Access' />
    <h1 className='h1'>403</h1>
    <h4 className='h4'>{strings.UNAUTHORIZED_SUB}</h4>
  </div>
);

export default Unauthorized;



// WEBPACK FOOTER //
// ./app/components/unauthorized.jsx